import React from "react";
import "./story-loading.m.css";

export const StoryLoading = props => (
  <div styleName="wrapper">
    <div styleName="animated-background">
      <div styleName="background-masker header-top" />
      <div styleName="background-masker header-left" />
      <div styleName="background-masker header-right" />
      <div styleName="background-masker header-bottom" />
      <div styleName="background-masker subheader-left" />
      <div styleName="background-masker subheader-right" />
      <div styleName="background-masker subheader-bottom" />
      <div styleName="background-masker content-top" />
      <div styleName="background-masker content-first-end" />
      <div styleName="background-masker content-second-line" />
      <div styleName="background-masker content-second-end" />
      <div styleName="background-masker content-third-line" />
      <div styleName="background-masker content-third-end" />
    </div>
  </div>
);
